import { toDataLayerObject, toQueryString } from '@/utils/utm';

export default {
  params: state => state.params,
  hasUtms: state => !!state.params,
  asDataLayerObject: state => toDataLayerObject(state.params),
  asQueryString: state => toQueryString(state.params),
};
